// Small table cell renderers shared by the /reports dashboards.

import {
  CHART_COLORS,
  formatMoney,
  formatNumber,
  formatPercent,
} from "../widgets/graphs/chartTheme.ts";
import { clean } from "./reportesUtils.ts";

export const Money = ({ value }: { value: number | null | undefined }) => (
  <span className="fd-num">{formatMoney(value)}</span>
);

export const Count = ({ value }: { value: number | null | undefined }) => (
  <span className="fd-num">{formatNumber(value)}</span>
);

// Percentage (0..100) with a thin bar
export const PctBar = ({
  value,
  color = CHART_COLORS.facturado,
}: {
  value: number | null | undefined;
  color?: string;
}) => {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className="fd-pct">
      <div className="fd-pct-bar">
        <div
          className="fd-pct-fill"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>
      <span className="fd-num">{formatPercent(value)}</span>
    </div>
  );
};

// Name + secondary text that applies a dashboard filter when clicked
export const FilterLink = ({
  name,
  sub,
  title,
  onClick,
}: {
  name: string;
  sub?: string;
  title: string;
  onClick: () => void;
}) => (
  <button type="button" className="fd-link" title={title} onClick={onClick}>
    <span className="fd-prov-name">{clean(name) || "-"}</span>
    {sub ? <span className="fd-prov-rut">{clean(sub)}</span> : null}
  </button>
);
